import * as classNames from 'classnames'
import * as React from 'react'
import { Route } from 'react-router'
import { IBankAccountObj, ICreateBankAccountObj, IMap, IOrgObj } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import BankAccountForm from './BankAccountForm'
import BankAccountListItem from './BankAccountListItem'
import RemoveBankAccountModal from './RemoveBankAccountModal'

interface IBankAccountProps {
  connectURL?: string | undefined
  bankAccount: ICreateBankAccountObj
  bankAccounts: IMap<IBankAccountObj>
  currentStep: number
  history: any
  isSaved: boolean
  isSaving: boolean
  isEdit?: boolean
  organization: IOrgObj
  match: any
  orgId: string
  isCompleted: boolean
  isBankAccountAdded?: boolean
  isLegalEntityCompleted?: boolean
  onCompleteStep: (step: number) => void
  showMessage: (error: string, isError: boolean) => void
  onSaveBankAccount: (bankAccount: ICreateBankAccountObj) => Promise<any>
  onRemoveBankAccount: (bankAccountId: string) => Promise<any>
  onSetPrimaryBankAccount: (bankAccountId: string) => Promise<any>
}

class BankAccountPane extends React.Component<IBankAccountProps> {
  public render() {
    const {
      bankAccount,
      bankAccounts,
      currentStep,
      isSaved,
      isSaving,
      isBankAccountAdded,
      isLegalEntityCompleted,
      onCompleteStep,
      onSaveBankAccount,
      onSetPrimaryBankAccount,
      showMessage
    } = this.props

    const getRemoveBankAccountModal = (props: any) => {
      return (
        <div>
          <RemoveBankAccountModal
            {...props}
            onClose={this.props.history.goBack}
            bankAccounts={this.props.bankAccounts}
            onRemove={this.props.onRemoveBankAccount}
          />
        </div>
      )
    }

    return (
      <section>
        <Route path={`${this.props.match.url}/bank-account/remove/:id`} component={getRemoveBankAccountModal} />
        <BankAccountForm
          connectURL={this.props.connectURL}
          currentStep={currentStep}
          orgId={this.props.orgId}
          isEdit={this.props.isEdit}
          organization={this.props.organization}
          isCompleted={this.props.isCompleted}
          bankAccount={bankAccount}
          bankAccounts={bankAccounts}
          isSaving={isSaving}
          match={this.props.match}
          isBankAccountAdded={isBankAccountAdded}
          isLegalEntityCompleted={isLegalEntityCompleted}
          showMessage={showMessage}
          onCompleteStep={onCompleteStep}
          onSaveBankAccount={onSaveBankAccount}
          onSetPrimaryBankAccount={onSetPrimaryBankAccount}
        />
      </section>
    )
  }
}

export default BankAccountPane



// WEBPACK FOOTER //
// ./src/components/organizations/create/bankaccount/BankAccount.tsx